/**
 * @generated SignedSource<<ffe4ee25c3e8202f147fff7af467b827>>
 * @relayHash 799d33c42a7ade753d48b7ebf40f7ea9
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 799d33c42a7ade753d48b7ebf40f7ea9

import type { ConcreteRequest } from 'relay-runtime';
export type TemplateListPaneQuery$variables = {
  id: string;
};
export type TemplateListPaneQuery$data = {
  readonly node: {
    readonly contactLinks?: ReadonlyArray<{
      readonly about: string;
      readonly name: string;
      readonly url: string;
    }> | null | undefined;
    readonly hasAnyTemplates?: boolean;
    readonly hasIssuesEnabled?: boolean;
    readonly id?: string;
    readonly isBlankIssuesEnabled?: boolean;
    readonly isBlankIssuesMaintainerOverride?: boolean;
    readonly isSecurityPolicyEnabled?: boolean | null | undefined;
    readonly issueForms?: ReadonlyArray<{
      readonly __typename: "IssueForm";
      readonly description: string | null | undefined;
      readonly filename: string;
      readonly name: string;
    }> | null | undefined;
    readonly issueTemplates?: ReadonlyArray<{
      readonly __typename: "IssueTemplate";
      readonly about: string | null | undefined;
      readonly filename: string;
      readonly name: string;
    }> | null | undefined;
    readonly nameWithOwner?: string;
    readonly securityPolicyUrl?: string | null | undefined;
  } | null | undefined;
};
export type TemplateListPaneQuery = {
  response: TemplateListPaneQuery$data;
  variables: TemplateListPaneQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasIssuesEnabled",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nameWithOwner",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "filename",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueForm",
  "kind": "LinkedField",
  "name": "issueForms",
  "plural": true,
  "selections": [
    (v5/*:: as any*/),
    (v6/*:: as any*/),
    (v7/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "about",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueTemplate",
  "kind": "LinkedField",
  "name": "issueTemplates",
  "plural": true,
  "selections": [
    (v5/*:: as any*/),
    (v6/*:: as any*/),
    (v7/*:: as any*/),
    (v9/*:: as any*/)
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isBlankIssuesEnabled",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isBlankIssuesMaintainerOverride",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSecurityPolicyEnabled",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "securityPolicyUrl",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "RepositoryContactLink",
  "kind": "LinkedField",
  "name": "contactLinks",
  "plural": true,
  "selections": [
    (v7/*:: as any*/),
    (v9/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasAnyTemplates",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TemplateListPaneQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v8/*:: as any*/),
              (v10/*:: as any*/),
              (v11/*:: as any*/),
              (v12/*:: as any*/),
              (v13/*:: as any*/),
              (v14/*:: as any*/),
              (v15/*:: as any*/),
              (v16/*:: as any*/)
            ],
            "type": "Repository",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "TemplateListPaneQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v5/*:: as any*/),
          (v3/*:: as any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*:: as any*/),
              (v4/*:: as any*/),
              (v8/*:: as any*/),
              (v10/*:: as any*/),
              (v11/*:: as any*/),
              (v12/*:: as any*/),
              (v13/*:: as any*/),
              (v14/*:: as any*/),
              (v15/*:: as any*/),
              (v16/*:: as any*/)
            ],
            "type": "Repository",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "799d33c42a7ade753d48b7ebf40f7ea9",
    "metadata": {},
    "name": "TemplateListPaneQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "12635b5d6d6fe81838951633df9e0117";

export default node;
